document.addEventListener('DOMContentLoaded', function () {
  const searchButton = document.getElementById('card-finder-search-button');
  const resultsContainer = document.getElementById('card-finder-results');
  const showBasicLandsCheckbox = document.getElementById('show-basic-lands');
  const loadingContainer = document.getElementById('card-finder-loading');
  const loadingMessage = document.getElementById('card-finder-loading-message');
  const progressBar = document.getElementById('card-finder-progress-bar');
  const progressText = document.getElementById('card-finder-progress-text');

  // Five card names means at most ten predictive-search requests at once:
  // one normal query and one foil query for each card.
  const SEARCH_BATCH_SIZE = 5;
  const STOCK_BATCH_SIZE = 5;
  const searchResultCache = new Map();

  const mtgQuips = [
    'Tearing Blacker Lotus into pieces...',
    'Tutoring for Primeval Titan...',
    'Printing some proxies...',
    'Playing 100 card pickup...',
    'DMing Richard Garfield...',
    'Inventing a time machine and buying old MTG...',
    'Resolving a very long stack...',
    'Checking every bulk rare twice...',
    'Looking for your missing Sol Ring...',
    'Convincing a mana base to behave...',
    'Cracking a fetch land for absolutely no reason...',
    'Mulling to 5 and pretending it\'s fine...',
    'Topdecking like a champion...',
    'Resolving a Cyclonic Rift… again...',
    'Arguing about priority...',
    'Reading the card… again...',
    'Untapping everything suspiciously...',
    'Checking if it has Ward...',
    'Forgetting upkeep triggers...',
    'Blaming mana screw...',
    'Blaming mana flood...',
    'Calling it a budget deck...',
    'Just one more upgrade...',
    'This deck definitely works now...',
    'Trust me, this combo is consistent...',
    'Checking Oracle text...',
    'Searching EDHREC for "inspiration"...',
    'Optimising your mana curve...',
    'Removing one more land...',
    'Floating mana just in case...',
    'Trying to remember what that trigger does...',
    'Definitely not missing lethal...',
    'Checking graveyards for value...',
    'Hovering over the concede button...',
    'Resolving layers… good luck...',
    'Applying replacement effects...',
    'Explaining why this works... trust me...',
    'Stacking triggers in the "correct" order...',
    'Reading Gatherer comments from 2006...',
    'Remembering this is a may ability...'
  ];

  function foldUnicode(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[Ææ]/g, match => match === 'Æ' ? 'AE' : 'ae')
      .replace(/[Œœ]/g, match => match === 'Œ' ? 'OE' : 'oe')
      .replace(/[Øø]/g, match => match === 'Ø' ? 'O' : 'o')
      .replace(/[Łł]/g, match => match === 'Ł' ? 'L' : 'l')
      .replace(/ß/g, 'ss');
  }

  function stripFoilSuffix(name) {
    return String(name || '')
      .replace(/\s*-\s*foil\s*$/i, '')
      .replace(/\s*\(foil\)\s*$/i, '')
      .trim();
  }

  function canonicalCardName(name) {
    return foldUnicode(stripFoilSuffix(name))
      .replace(/[\u2018\u2019\u02BC]/g, "'")
      .replace(/[\u2010\u2011\u2012\u2013\u2014]/g, '-')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getProductHandle(url) {
    const match = String(url || '').match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function canonicalProductUrl(product) {
    const handle = getProductHandle(product?.url);
    return handle ? `/products/${handle}` : String(product?.url || '').split('?')[0];
  }

  function productIdentity(product) {
    if (product?.id) return `id:${product.id}`;

    const handle = getProductHandle(product?.url);
    if (handle) return `handle:${handle}`;

    return `fallback:${canonicalCardName(product?.title)}:${canonicalProductUrl(product)}`;
  }

  function cleanCardList(rawText) {
    const lines = rawText.split('\n');
    const cardNames = [];

    lines.forEach(rawLine => {
      let line = rawLine.trim();
      const lower = line.toLowerCase();

      if (
        !line ||
        lower.startsWith('deck') ||
        lower.startsWith('sideboard') ||
        lower.startsWith('commander') ||
        lower.startsWith('about') ||
        lower.startsWith('name ')
      ) {
        return;
      }

      // Remove a leading deck-list quantity: "1 Card", "1x Card", etc.
      line = line.replace(/^\d+x?\s*/i, '');

      // Remove common "(SET) collector-number" suffixes, including unusual
      // Scryfall numbers such as 75★ and 206†, plus optional *F* markers.
      line = line.replace(
        /\s+\([a-z0-9]+\)\s+\S+(?:\s+\*[^*]+\*)?\s*$/i,
        ''
      );

      // Remove any remaining foil/export marker. The finder searches both
      // normal and foil products regardless of how the pasted list was marked.
      line = line
        .replace(/\s+\*F\*\s*$/i, '')
        .replace(/\s+\*E\*\s*$/i, '');

      line = stripFoilSuffix(line).trim();

      if (line) cardNames.push(line);
    });

    return cardNames;
  }

  function uniqueCardNames(cardNames) {
    const unique = new Map();

    cardNames.forEach(name => {
      const displayName = stripFoilSuffix(name);
      const key = canonicalCardName(displayName);
      if (key && !unique.has(key)) unique.set(key, displayName);
    });

    return [...unique.values()];
  }

  const basicLandNames = new Set([
    'plains',
    'island',
    'swamp',
    'mountain',
    'forest',
    'wastes'
  ]);

  function isBasicLand(cardName) {
    return basicLandNames.has(canonicalCardName(cardName));
  }

  async function fetchSuggestedProducts(query) {
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '10');
    params.set('resources[options][unavailable_products]', 'hide');
    params.set(
      'resources[options][fields]',
      'title,product_type,variants.title'
    );

    const response = await fetch(`/search/suggest.json?${params.toString()}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error(
        `Search request failed for "${query}" with status ${response.status}`
      );
    }

    const data = await response.json();
    return data?.resources?.results?.products || [];
  }

  async function searchProductsForCard(cardName) {
    const canonicalName = canonicalCardName(cardName);

    if (searchResultCache.has(canonicalName)) {
      return searchResultCache.get(canonicalName);
    }

    // Keep both searches because Shopify predictive search may not include a
    // foil product among the limited results for the normal title. Running
    // them together removes the old sequential wait.
    const queries = [cardName, `${cardName} - FOIL`];
    const responses = await Promise.allSettled(
      queries.map(query => fetchSuggestedProducts(query))
    );

    const successfulResponses = responses.filter(
      result => result.status === 'fulfilled'
    );

    if (successfulResponses.length === 0) {
      throw responses[0].reason;
    }

    const productsByIdentity = new Map();

    successfulResponses.forEach(result => {
      result.value.forEach(product => {
        if (canonicalCardName(product.title) !== canonicalName || !product.url) {
          return;
        }

        const key = productIdentity(product);

        if (!productsByIdentity.has(key)) {
          productsByIdentity.set(key, {
            ...product,
            // Remove Shopify predictive-search tracking parameters so the same
            // product returned by normal and foil queries has one stable URL.
            url: canonicalProductUrl(product)
          });
        }
      });
    });

    const products = [...productsByIdentity.values()];
    searchResultCache.set(canonicalName, products);
    return products;
  }

  let quipInterval;

  function startCardFinderLoading() {
    if (loadingContainer) loadingContainer.style.display = 'block';
    if (progressBar) progressBar.style.width = '0%';
    if (progressText) progressText.textContent = '0%';

    let quipIndex = Math.floor(Math.random() * mtgQuips.length);

    if (loadingMessage) loadingMessage.textContent = mtgQuips[quipIndex];

    clearInterval(quipInterval);

    quipInterval = setInterval(() => {
      let nextIndex;

      do {
        nextIndex = Math.floor(Math.random() * mtgQuips.length);
      } while (nextIndex === quipIndex && mtgQuips.length > 1);

      quipIndex = nextIndex;

      if (loadingMessage) {
        loadingMessage.textContent = mtgQuips[quipIndex];
      }
    }, 1400);
  }

  function updateCardFinderProgress(done, total) {
    const percent = total > 0 ? Math.round((done / total) * 100) : 0;
    if (progressBar) progressBar.style.width = `${percent}%`;
    if (progressText) progressText.textContent = `${percent}%`;
  }

  function stopCardFinderLoading() {
    clearInterval(quipInterval);
    if (loadingContainer) loadingContainer.style.display = 'none';
  }

  async function processInBatches(items, batchSize, asyncFn) {
    const results = [];

    for (let i = 0; i < items.length; i += batchSize) {
      const batch = items.slice(i, i + batchSize);
      const batchResults = await Promise.all(
        batch.map((item, batchIndex) => asyncFn(item, i + batchIndex))
      );
      results.push(...batchResults);
    }

    return results;
  }

  searchButton.addEventListener('click', async function () {
    try {
    const input = document.getElementById('card-finder-input').value;
    let cardNames = cleanCardList(input);

    const showBasics = showBasicLandsCheckbox && showBasicLandsCheckbox.checked;

    if (!showBasics) {
      cardNames = cardNames.filter(cardName => !isBasicLand(cardName));
    }

    // A pasted list can contain the same card more than once. Search each
    // distinct card name once while still showing every available printing.
    cardNames = uniqueCardNames(cardNames);

    if (cardNames.length === 0) {
      resultsContainer.innerHTML = '<p>No searchable cards found.</p>';
      return;
    }
    
    resultsContainer.innerHTML = '';
    
    // Remove previous not found box if it exists
    const previousNotFoundBox = document.querySelector('.not-found-box');
    if (previousNotFoundBox) previousNotFoundBox.remove();
    
    const oldMissing = document.querySelector('.card-finder-not-found');
    if (oldMissing) oldMissing.remove();

    startCardFinderLoading();
    searchButton.disabled = true;

    let matches = [];
    let processedCount = 0;
    const matchesByIdentity = new Map();

    await processInBatches(
      cardNames,
      SEARCH_BATCH_SIZE,
      async cardName => {
        try {
          const products = await searchProductsForCard(cardName);

          products.forEach(product => {
            const key = productIdentity(product);
            if (!matchesByIdentity.has(key)) {
              matchesByIdentity.set(key, product);
            }
          });
        } catch (error) {
          console.error('Error searching for card:', cardName, error);
        } finally {
          processedCount += 1;
          const searchPercent = Math.round(
            (processedCount / cardNames.length) * 70
          );
          if (progressBar) progressBar.style.width = `${searchPercent}%`;
          if (progressText) progressText.textContent = `${searchPercent}%`;
        }
      }
    );

    matches = [...matchesByIdentity.values()];

    const cart = await fetch('/cart.js').then(res => res.json()).catch(() => ({ items: [] }));
    const cartItemsByVariant = {};
    cart.items.forEach(item => {
      cartItemsByVariant[item.variant_id] = (cartItemsByVariant[item.variant_id] || 0) + item.quantity;
    });

    if (matches.length > 0) {
      let enrichedCount = 0;
      const totalToEnrich = matches.length;
      const stockCache = {};

      const enrichedMatches = await processInBatches(matches, STOCK_BATCH_SIZE, async (product, index) => {
        const productCopy = { ...product };
        const handle = product.url.split('/products/')[1].split('?')[0];

        try {
          let productData;

          if (stockCache[handle]) {
            productData = stockCache[handle];
          } else {
            const res = await fetch(`https://gregarious-dolphin-121e8f.netlify.app/.netlify/functions/get-product-stock?handle=${handle}`);

            if (!res.ok) {
              throw new Error(`Stock request failed for ${handle} with status ${res.status}`);
            }

            productData = await res.json();
            stockCache[handle] = productData;
          }

          const variants = [];
          const productTags = (productData.tags || []).map(t => t.toLowerCase());

          productData.variants.forEach(v => {
            const vId = parseInt(v.id, 10);
            const rawQty = typeof v.quantityAvailable === 'number' ? v.quantityAvailable : 0;
            const cartQty = cartItemsByVariant[vId] || 0;
            const adjustedQty = Math.max(rawQty - cartQty, 0);

            let badges = [];

            if (productTags.includes('etched')) {
              badges.push('<span class="card__badge pill-badge etched-badge">Etched</span>');
            }

            if (productTags.includes('foil')) {
              badges.push('<span class="card__badge pill-badge foil-badge">Foil</span>');
            }

            const conditionLabels = {
              nm: "Near Mint",
              lp: "Lightly Played",
              mp: "Moderately Played",
              hp: "Heavily Played"
            };

            Object.entries(conditionLabels).forEach(([code, label]) => {
              if (productTags.includes(code)) {
                badges.push(`<span class="card__badge pill-badge condition-badge ${code}" title="${label}">${code.toUpperCase()}</span>`);
              }
            });

            variants.push({
              id: v.id.split('/').pop(),
              title: v.title,
              price: parseFloat(v.price),
              stock: adjustedQty,
              badges_html: badges.join('')
            });
          });

          productCopy.variants_rendered = variants;
          productCopy.has_multiple_variants = variants.length > 1;
          productCopy.selected_variant_index = 0;
          productCopy.image = product.image;
          productCopy.title = product.title;
          productCopy.url = product.url;
          productCopy.index = index;
          productCopy.stock_failed = false;

        } catch (error) {
          console.error('Error fetching variant data', handle, error);

          productCopy.variants_rendered = [];
          productCopy.has_multiple_variants = false;
          productCopy.selected_variant_index = 0;
          productCopy.image = product.image;
          productCopy.title = product.title;
          productCopy.url = product.url;
          productCopy.index = index;
          productCopy.stock_failed = true;
        }

        enrichedCount += 1;
        const enrichPercent = 70 + Math.round((enrichedCount / totalToEnrich) * 30);
        if (progressBar) progressBar.style.width = `${enrichPercent}%`;
        if (progressText) progressText.textContent = `${enrichPercent}%`;

        return productCopy;
      });

      resultsContainer.innerHTML = `
        <div class="grid product-grid contains-card contains-card--product">
          ${enrichedMatches.map(product => {
          const first = product.variants_rendered?.[product.selected_variant_index];
          const isStockFailed = product.stock_failed;

          if (!first && !isStockFailed) return '';

          const variantOptions = (!isStockFailed && product.has_multiple_variants)
            ? `<select class="variant-selector" data-index="${product.index}">
                ${product.variants_rendered.map((v, vi) => `<option value="${vi}">${v.title}</option>`).join('')}
              </select>`
            : '';

          const badgeHTML = (!isStockFailed && first) ? (first.badges_html || '') : '';
          const disabled = (isStockFailed || !first || first.stock <= 0) ? 'disabled' : '';
          const buttonText = isStockFailed
            ? 'Stock Unavailable'
            : (first.stock <= 0 ? 'Sold Out' : 'Add to Cart');

          const stockText = isStockFailed
            ? 'Stock unavailable'
            : `Quantity: ${first.stock}`;

          const priceText = isStockFailed
            ? ''
            : `£${first.price.toFixed(2)}`;

          const hiddenInput = (!isStockFailed && first)
            ? `<input type="hidden" name="id" value="${first.id}">`
            : '';

            return `
              <div class="grid__item scroll-trigger animate--slide-in" style="--animation-order: ${product.index};">
                <div class="card-wrapper product-card-wrapper underline-links-hover">
                  <div class="card card--standard card--media card--extend-height">
                    <div class="card__inner ratio" style="--ratio-percent: 139.29%;">
                      <div class="card__media">
                        <div class="media media--transparent media--hover-effect">
                          <a href="${product.url}" class="full-unstyled-link">
                            <img src="${product.image}" alt="${product.title}" class="motion-reduce" loading="lazy">
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="card__content">
                      <div class="card__information">
                        <h3 class="card__heading h5">
                          <a href="${product.url}" class="full-unstyled-link">${product.title}</a>
                        </h3>
                        ${variantOptions}
                        <div class="variant-info" data-index="${product.index}">
                        <div class="card__badges">${badgeHTML}</div>
                        <p class="card-finder-stock">${stockText}</p>
                        ${priceText ? `<p class="card-information__price">${priceText}</p>` : ''}
                        <form method="post" action="/cart/add.js" class="card-finder-add-to-cart-form" data-ajax-cart="true">
                          ${hiddenInput}
                          <button type="submit" class="button button--full-width button--secondary" ${disabled}>
                            ${buttonText}
                          </button>
                        </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            `;
          }).join('')}
        </div>
      `;

      // Build a set of matched base names. Accents, smart apostrophes and
      // the optional foil suffix are ignored for this comparison.
      const matchedCanonical = new Set(
        matches.map(product => canonicalCardName(product.title))
      );

      const finalNotFound = cardNames.filter(
        name => !matchedCanonical.has(canonicalCardName(name))
      );

      // Show not found box
      if (finalNotFound.length > 0) {
        const notFoundHTML = `
          <div class="not-found-box">
            <h3>Cards Not Found:</h3>
            <ul>
              ${finalNotFound.map(name => `<li>${escapeHTML(name)}</li>`).join('')}
            </ul>
          </div>
        `;
        resultsContainer.insertAdjacentHTML('afterend', notFoundHTML);
      }

      window._cardFinderProducts = enrichedMatches;
      attachVariantSelectors(enrichedMatches);
    } else {
      resultsContainer.innerHTML = '<p>No matching cards found.</p>';

      const notFoundHTML = `
        <div class="not-found-box">
          <h3>Cards Not Found:</h3>
          <ul>
            ${cardNames.map(name => `<li>${escapeHTML(name)}</li>`).join('')}
          </ul>
        </div>
      `;
      resultsContainer.insertAdjacentHTML('afterend', notFoundHTML);
    }
    } catch (error) {
      console.error('Card Finder failed:', error);
      resultsContainer.innerHTML =
        '<p>Something went wrong while searching. Please try again.</p>';
    } finally {
      searchButton.disabled = false;
      stopCardFinderLoading();
    }
  });

  function attachVariantSelectors(products) {
    document.querySelectorAll('.variant-selector').forEach(selector => {
      selector.addEventListener('change', function () {
        const index = parseInt(this.getAttribute('data-index'), 10);
        const selectedIndex = parseInt(this.value, 10);
        const variant = products[index].variants_rendered[selectedIndex];
        const infoContainer = document.querySelector(`.variant-info[data-index="${index}"]`);
        if (!infoContainer || !variant) return;

        infoContainer.querySelector('.card__badges').innerHTML = variant.badges_html;
        infoContainer.querySelector('.card-finder-stock').textContent = `Quantity: ${variant.stock}`;
        infoContainer.querySelector('.card-information__price').textContent = `£${variant.price.toFixed(2)}`;
        infoContainer.querySelector('input[name="id"]').value = variant.id;

        const button = infoContainer.querySelector('button[type="submit"]');
        button.disabled = variant.stock <= 0;
        button.textContent = variant.stock <= 0 ? 'Sold Out' : 'Add to Cart';
        button.style.pointerEvents = '';
        button.style.cursor = '';
      });
    });
  }

  document.addEventListener('submit', async function (e) {
    if (e.target.matches('.card-finder-add-to-cart-form')) {
      e.preventDefault();
      const form = e.target;
      const submitButton = form.querySelector('button[type="submit"]');
      const variantId = form.querySelector('input[name="id"]').value;
      const stockElement = form.closest('.variant-info')?.querySelector('.card-finder-stock');
      const stockMatch = stockElement?.textContent.match(/Quantity:\s*(\d+)/i);
      let currentStock = stockMatch ? parseInt(stockMatch[1], 10) : 0;

      if (currentStock <= 0) {
        submitButton.disabled = true;
        submitButton.textContent = 'Sold Out';
        return;
      }

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      try {
        const response = await fetch('/cart/add.js', {
          credentials: 'same-origin',
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (response.ok) {
          currentStock -= 1;
          stockElement.textContent = `Quantity: ${currentStock}`;

          const productIndex = parseInt(form.closest('.variant-info')?.dataset.index, 10);
          const products = window._cardFinderProducts || [];
          const product = products[productIndex];
          if (product) {
            const variant = product.variants_rendered.find(v => v.id === variantId);
            if (variant) {
              variant.stock = currentStock;
            }
          }

          if (currentStock <= 0) {
            submitButton.disabled = true;
            submitButton.textContent = 'Sold Out';
            submitButton.style.pointerEvents = 'none';
            submitButton.style.cursor = 'not-allowed';
          }

          showToast('Added to cart!');
        } else {
          showToast('Failed to add to cart. Try again.');
        }
      } catch (error) {
        console.error('Network error:', error);
      }
    }
  });

  function showToast(message) {
    const container = document.getElementById('card-finder-toast-container');
    if (!container) return;

    const toast = document.createElement('div');
    toast.className = 'card-finder-toast';
    toast.textContent = message;

    container.appendChild(toast);
    setTimeout(() => { toast.remove(); }, 2300);
  }

  const helpSection = document.querySelector('.card-finder-help');
  const cardInput = document.getElementById('card-finder-input');
  
  let hasHighlightedHelp = false;
  
  cardInput.addEventListener('focus', () => {
    if (!hasHighlightedHelp && helpSection) {
      helpSection.classList.add('highlight');
      hasHighlightedHelp = true;
  
      // Remove the highlight after a few seconds
      setTimeout(() => {
        helpSection.classList.remove('highlight');
      }, 4500);
    }
  });
});